module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"@:labels.cancel","name":"@:labels.name","required":"@:labels.required","save":"@:labels.save","newTitle":"New Client","editTitle":"Edit Client"},"fr":{"cancel":"@:labels.cancel","name":"@:labels.name","required":"@:labels.required","save":"@:labels.save","newTitle":"Nouveau client","editTitle":"Modifier le client"}}')
  delete Component.options._Ctor
}
